export default __webpack_public_path__ + "b3cff856055ddf9ab50af5195a8e5790.webp";